import React, { useEffect, useState } from 'react';
import BasicDrawer from '../../../components/Drawer';
import { useForm, Controller } from 'react-hook-form';
import { Col, ConfigProvider, Row, TimePicker } from 'antd';
import LabelWithSelect from '../../../components/LabelWithSelect';
import { ApiCaller, Colors, Utils } from '../../../config';
import LabelWithTimePicker from '../../../components/LabelWithTimePicker';
import LabelWithField from '../../../components/LabelWithField';
import { Button, TextField } from '../../../components';
import RangeDatePicker from '../../../components/Picker/RangePicker';
import dayjs from 'dayjs';
import moment from 'moment';
import { useMutation, useQuery } from 'react-query';
import { getAllUsers, getShiftsForUser } from '../../../config/getApis';
import { yupResolver } from '@hookform/resolvers/yup';
import { TorRequestSchema } from '../../../config/Schema';
import { useDispatch, useSelector } from 'react-redux';
import {
    ShiftDropOrSwap,
    ShiftTorAction,
    UserManagementAction,
} from '../../../store/actions';
import BasicText from '../../../components/Text/BasicText';
import useColors from '../../../hooks/useColors';

const RequestTimeOffDrawer = ({
    drawerStates,
    setDrawerStates,
    timeOffRequest,
    setTimeOffRequest,
}) => {
    const { colorPrimary } = useColors();

    const [state, setState] = useState({
        startTime: '',
        endTime: '',
        startDate: '',
        endDate: '',
        paidHoursLeft: 0,
    });

    // validations only for time and date, rest will be handle by the useForm and yup.
    const [validation, setValidations] = useState({
        startTime: '',
        endTime: '',
        startDate: '',
    });

    const usersOptions = useQuery('users', () => getAllUsers('', '', 'fullName'), {
        enabled: drawerStates?.requestTimeOffDrawerOpen,
    });

    const userDetailData = useSelector(
        (state) => state?.UserManagementReducer?.UserDetailData,
    );

    const dispatch = useDispatch();

    const defaultValues = {
        userId: '',
        type: '',
        notes: '',
        shiftId: '',
    };
    const schema = TorRequestSchema;

    const { handleSubmit, control, reset, setValue, watch } = useForm({
        // mode: 'onChange',
        // resolver: yupResolver(schema),
        // defaultValues: defaultValues,
    });

    const watchFields = watch(['userId', 'type']);
    const selectedShiftId = watch('shiftId');
    let [userId, type] = watchFields;

    let user = userId;
    let typeOffRequst = type;
    const shiftOptions = useQuery(
        ['shifts', userId], // A unique query key, including userId
        () => getShiftsForUser(userId), // Pass a function that calls the API
        {
            enabled: drawerStates?.requestTimeOffDrawerOpen, // Ensures query only runs if conditions are met
        },
    );

    console.log('Selected Shift ID:', selectedShiftId);

    useEffect(() => {
        if (user && typeOffRequst) {
            let payload = {
                id: Number(user),
            };
            dispatch(UserManagementAction.GetUserDetail(payload));
            user = '';
            typeOffRequst = '';
        }
    }, [user, typeOffRequst]);

    useEffect(() => {
        if (userDetailData?.paidHours) {
            let paidHoursLeft = null;
            switch (type) {
                case 'personal':
                    paidHoursLeft =
                        userDetailData?.paidHours?.remainingPersonal;
                    break;
                case 'sick':
                    paidHoursLeft = userDetailData?.paidHours?.remainingSick;
                    break;
                case 'vacation':
                    paidHoursLeft =
                        userDetailData?.paidHours?.remainingVacation;
                    break;
                default:
                    paidHoursLeft = null;
            }
            setState((prevState) => ({ ...prevState, paidHoursLeft }));
        }
    }, [userDetailData]);

    const closeHandler = () => {
        setDrawerStates({ ...drawerStates, requestTimeOffDrawerOpen: false });
        reset(defaultValues);
        setState({
            startTime: '',
            endTime: '',
            startDate: '',
            endDate: '',
            paidHoursLeft: 0,
        });
    };
    console.log('idd', userId);

    // const TorRequestMutation = useMutation(
    //     async ({ data, userId }) => {
    //         // Assigning userId to a variable named user
    //         let user = userId;
    //         let res = await ApiCaller.Post(
    //             `/admin/shift/${user}/drop-request`,
    //             data,
    //         );
    //         return res;
    //     },
    //     {
    //         onSuccess: (res) => {
    //             const { page, limit, search, filterDrawer } = timeOffRequest;
    //             const { status, timeOffType, dateStr } = filterDrawer;
    //             setDrawerStates({
    //                 ...drawerStates,
    //                 requestTimeOffDrawerOpen: false,
    //             });
    //             Utils.showMessage('success', res?.data?.message);
    //             dispatch(
    //                 ShiftDropOrSwap.GetDropOrSwap({
    //                     page: page,
    //                     limit: limit,
    //                     search: search,
    //                     filterDrawer: {
    //                         status: status,
    //                     },
    //                 }),
    //             );
    //             setTimeOffRequest({
    //                 ...timeOffRequest,
    //                 page: page,
    //                 limit: limit,
    //                 search: search,
    //                 filterDrawer: {
    //                     status: status,
    //                     timeOffType: timeOffType,
    //                     dateStr: dateStr,
    //                 },
    //             });
    //             reset(defaultValues);
    //             setState({
    //                 startTime: '',
    //                 endTime: '',
    //                 startDate: '',
    //                 endDate: '',
    //                 paidHoursLeft: 0,
    //             });
    //         },
    //         onError: (error) => {
    //             Utils.showMessage('error', error?.response?.data?.message);
    //         },
    //     },
    // );

    // const submitHandler = (data) => {
    //     // if (
    //     //     !state?.startTime ||
    //     //     !state?.endTime ||
    //     //     !state?.startDate ||
    //     //     !state?.endDate
    //     // ) {
    //     //     setValidations({
    //     //         startTime: !state?.startTime ? 'Start time is required' : '',
    //     //         endTime: !state?.endTime ? 'End time is required' : '',
    //     //         startDate: !state?.startDate ? 'Date is required' : '',
    //     //     });
    //     //     return;
    //     // } else if (
    //     //     state?.startTime &&
    //     //     state?.endTime &&
    //     //     state?.startDate &&
    //     //     state?.endDate
    //     // ) {
    //     //     setValidations({
    //     //         startTime: '',
    //     //         endTime: '',
    //     //         startDate: '',
    //     //     });
    //     //     if (
    //     //         dayjs(state.startTime, 'HH:mm').format('HH:mm') ==
    //     //         dayjs(state.endTime, 'HH:mm').format('HH:mm')
    //     //     ) {
    //     //         console.log(
    //     //             dayjs(state.startTime, 'HH:mm').format('HH:mm'),
    //     //             dayjs(state.endTime, 'HH:mm').format('HH:mm'),
    //     //         );
    //     //         Utils.showMessage('error', 'Start and End Time cannot be same');
    //     //         return;
    //     //     }
    //     TorRequestMutation.mutate(data);
    //     // }

    //     alert('submit');
    // };
    const TorRequestMutation = useMutation(
        async (data) => {
            const { selectedShiftId, reason, userId } = data;

            if (!selectedShiftId) {
                throw new Error('Selected shift ID is required.');
            }

            // Construct the payload explicitly
            const payload = {
                userId, // Include userId if required by the API
                reason,
            };

            const res = await ApiCaller.Post(
                `/admin/shift/${selectedShiftId}/drop-request`,
                payload, // Send the entire payload
            );

            return res;
        },
        {
            onSuccess: (res) => {
                const { page, limit, search, filterDrawer } = timeOffRequest;
                const { status, timeOffType, dateStr } = filterDrawer;

                setDrawerStates({
                    ...drawerStates,
                    requestTimeOffDrawerOpen: false,
                });

                Utils.showMessage('success', res?.data?.message);

                dispatch(
                    ShiftDropOrSwap.GetDropOrSwap({
                        page,
                        limit,
                        search,
                        filterDrawer: { status },
                    }),
                );

                setTimeOffRequest({
                    ...timeOffRequest,
                    page,
                    limit,
                    search,
                    filterDrawer: {
                        status,
                        timeOffType,
                        dateStr,
                    },
                });

                reset(defaultValues);

                setState({
                    startTime: '',
                    endTime: '',
                    startDate: '',
                    endDate: '',
                    paidHoursLeft: 0,
                });
            },
            onError: (error) => {
                Utils.showMessage('error', error?.response?.data?.message);
            },
        },
    );

    const submitHandler = (data) => {
        if (!selectedShiftId) {
            console.error('Selected shift ID is missing.');
            return;
        }

        const payload = {
            userId: data.userId,
            reason: data.notes,
            selectedShiftId, // Add the selectedShiftId to the payload
        };
        console.log('payloadssssss', payload);

        TorRequestMutation.mutate(payload, {
            onSuccess: (response) => {
                console.log('Request successful:', response);
            },
            onError: (error) => {
                console.error('Request failed:', error);
            },
        });
    };

    console.log('shiftOptions?.data', shiftOptions?.data);

    return (
        <>
            <BasicDrawer
                openDrawer={drawerStates.requestTimeOffDrawerOpen}
                onClose={closeHandler}
                title={'Create Request Swap/Drop'}
                width={500}
                children={
                    <>
                        <form>
                            <Row
                                className="w-full flex items-center mb-4 justify-center"
                                gutter={[4]}
                            >
                                <Col lg={24} md={24} sm={24} xs={24}>
                                    <Controller
                                        name="userId"
                                        defaultValue=""
                                        control={control}
                                        render={({ field, fieldState }) => (
                                            <>
                                                <LabelWithSelect
                                                    options={
                                                        usersOptions?.data
                                                            ? usersOptions?.data
                                                            : []
                                                    }
                                                    field={field}
                                                    labeltext={'Assign to'}
                                                    inputClass={
                                                        'w-full py-1 outline-none rounded h-9'
                                                    }
                                                    labelClass="font-normal"
                                                    style={{
                                                        color: Colors.LabelColor,
                                                    }}
                                                />
                                                {fieldState?.error && (
                                                    <p
                                                        style={{
                                                            color: Colors.Error,
                                                        }}
                                                    >
                                                        {
                                                            fieldState?.error
                                                                .message
                                                        }
                                                    </p>
                                                )}
                                            </>
                                        )}
                                    />
                                </Col>
                            </Row>

                            <Row
                                className="w-full flex items-center mb-4 justify-center"
                                gutter={[4]}
                            >
                                <Col lg={24} md={24} sm={24} xs={24}>
                                    <Controller
                                        name="shiftId"
                                        defaultValue=""
                                        control={control}
                                        render={({ field, fieldState }) => {
                                            const today = new Date()
                                                .toISOString()
                                                .split('T')[0]; // Get today's date in YYYY-MM-DD format

                                            // Filter shifts: Keep only today and future shifts
                                            const filteredShifts =
                                                shiftOptions?.data?.filter(
                                                    (shift) => {
                                                        const shiftDate =
                                                            shift.label.split(
                                                                ' ',
                                                            )[0]; // Extract YYYY-MM-DD from label
                                                        return (
                                                            shiftDate >= today
                                                        ); // Keep today's and future shifts
                                                    },
                                                ) || [];

                                            return (
                                                <>
                                                    <LabelWithSelect
                                                        options={filteredShifts}
                                                        field={field}
                                                        labeltext={'Shifts'}
                                                        inputClass={
                                                            'w-full py-1 outline-none rounded h-9'
                                                        }
                                                        labelClass="font-normal"
                                                        style={{
                                                            color: Colors.LabelColor,
                                                        }}
                                                    />
                                                    {fieldState?.error && (
                                                        <p
                                                            style={{
                                                                color: Colors.Error,
                                                            }}
                                                        >
                                                            {
                                                                fieldState
                                                                    ?.error
                                                                    .message
                                                            }
                                                        </p>
                                                    )}
                                                </>
                                            );
                                        }}
                                    />
                                </Col>
                            </Row>

                            <Row
                                gutter={[4]}
                                className="w-full flex items-center justify-start mb-4"
                            >
                                <Col span={24}>
                                    <Controller
                                        name="notes"
                                        control={control}
                                        defaultValue=""
                                        render={({
                                            field: { value, onChange },
                                            fieldState,
                                        }) => (
                                            <div className="">
                                                <TextField.Textarea
                                                    style={{
                                                        color: Colors.LightGray,
                                                    }}
                                                    placeholder={'Message'}
                                                    value={value}
                                                    onChange={onChange}
                                                    labeltext={'Reason'}
                                                    className={
                                                        'outline-none h-10 rounded'
                                                    }
                                                />
                                                {fieldState?.error && (
                                                    <p
                                                        style={{
                                                            color: Colors.Error,
                                                        }}
                                                    >
                                                        {
                                                            fieldState?.error
                                                                .message
                                                        }
                                                    </p>
                                                )}
                                            </div>
                                        )}
                                    />
                                </Col>
                            </Row>

                            <Row gutter={[10]} className="mt-6 px-2">
                                <Col span={24} className="flex justify-end">
                                    <Button.Basic
                                        loader={TorRequestMutation?.isLoading}
                                        onClick={handleSubmit(submitHandler)}
                                        size={'large'}
                                        text={'Create'}
                                        className={'rounded-md h-11 px-6'}
                                        style={{
                                            backgroundColor: colorPrimary,
                                            color: 'white',
                                        }}
                                    />
                                </Col>
                            </Row>
                        </form>
                    </>
                }
            />
        </>
    );
};

export default RequestTimeOffDrawer;
